import React from "react";
import api from "../lib/api";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    try {
      api.post("/client-error", {
        message: String(error?.message || error),
        stack: info?.componentStack || "",
        url: typeof window !== "undefined" ? window.location.href : "",
      });
    } catch { /* ignore */ }
    if (process.env.NODE_ENV === "development") console.error(error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" className="min-h-[60vh] flex items-center justify-center p-6">
          <div className="max-w-md text-center card-lux p-8">
            <h2 className="font-serif text-2xl text-forest">Something went wrong</h2>
            <p className="text-sm text-stone-500 mt-2">Unable to load this content. Please try again.</p>
            <div className="flex gap-3 justify-center mt-5">
              <button onClick={() => window.location.reload()} className="btn-primary">Reload</button>
              <a href="/" className="btn-dark">Go home</a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
